"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppointmentEventStruct = exports.AppointmentEventTypeStruct = void 0;
const superstruct_1 = require("superstruct");
const EventAppointment_1 = require("./EventAppointment");
const EventPlace_1 = require("./EventPlace");
exports.AppointmentEventTypeStruct = (0, superstruct_1.enums)([
    'created',
    'walk-in',
    'updated',
    'processed',
    'queue-in',
    'cancelled',
    'rejected',
    'confirmed',
    'invited',
    'backToQueue',
    'backToAppointments',
]);
exports.AppointmentEventStruct = (0, superstruct_1.type)({
    eventType: exports.AppointmentEventTypeStruct,
    place: EventPlace_1.EventPlaceStruct,
    appointment: EventAppointment_1.EventAppointmentStruct,
    queue: (0, superstruct_1.optional)((0, superstruct_1.array)(EventAppointment_1.EventAppointmentStruct)),
});
//# sourceMappingURL=AppointmentEvent.js.map